export default "__VITE_ASSET__DCc8ecpx__"